import { useEffect } from "react";
function useOnSizeChange(elementSize, onSizeChange) {
  const { width, height } = elementSize;
  useEffect(() => {
    onSizeChange?.({ height, width });
  }, [width, height, onSizeChange]);
}
export {
  useOnSizeChange
};
//# sourceMappingURL=useOnSizeChange.js.map
